<template>
    <section class="slider">
        <div id="heroCarousel" class="owl-carousel owl-theme">
            <div v-for="slide in slides" class="slide" :style="{backgroundImage : 'url('+ slide.image +')'}"></div>
        </div>
    </section>
</template>

<script>
export default {
    props: [],
    data() {
        return {
            loading : true,
            slides : [],
            owl: null,
        }
    },
    methods: {
        loadSlides() {
            axios.get('/api/hero-slides')
                 .then(response => {
                     this.slides = response.data;
                     this.loading = false;

                     this.eventHub.$emit('slideCountUpdated', this.slides.length);

                     Vue.nextTick(() => {
                        this.initCarousel();
                     })
                 });
        },
        initCarousel() {
            this.owl = jQuery('#heroCarousel').owlCarousel({
                nav: false,
                dots: false,
                items: 1,
                mouseDrag: false,
                touchDrag: false,
                autoplay: true,
                autoplayTimeout: 6000,
                animateOut: 'fadeOut',
                loop: true,
            });

            let randomSlideIndex = Math.floor(Math.random() * this.slides.length);
            this.owl.trigger('to.owl.carousel', randomSlideIndex)
            this.eventHub.$emit('activeSlideChanged', randomSlideIndex);

            this.owl.on('changed.owl.carousel', event => {
                let current = (event.item.index + 1) - event.relatedTarget._clones.length / 2;
                let itemsCount = event.item.count;

                if (current > itemsCount || current == 0) {
                    current = itemsCount - (current % itemsCount);
                }
                this.eventHub.$emit('activeSlideChanged', current-1);
            })
        }
    },
    mounted() {
        this.loadSlides();

        this.eventHub.$on('activateSlide', count => {
            this.owl.trigger('to.owl.carousel', count-1);

            // we stop and start autoplay to restart counting after manual slide change
            this.owl.trigger('stop.owl.autoplay');
            this.owl.trigger('play.owl.autoplay');
        });
    }
}
</script>
